import { render, staticRenderFns } from "./Rss.vue?vue&type=template&id=c172dbaa&scoped=true&"
import script from "./Rss.vue?vue&type=script&lang=ts&"
export * from "./Rss.vue?vue&type=script&lang=ts&"
import style0 from "./Rss.vue?vue&type=style&index=0&id=c172dbaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c172dbaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VList,VListItem,VListItemGroup,VSubheader})
